import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PROCESS_STEPS, REFERRAL_LIST, BRAND } from "@/lib/site";

export default function ProcessPage() {
  return (
    <div data-testid="process-page" className="container-x py-16 md:py-24">
      <div className="max-w-3xl">
        <span className="eyebrow">Our Process</span>
        <h1 className="mt-4 h-display text-4xl sm:text-5xl lg:text-6xl">
          How we win, together.
        </h1>
        <p className="mt-6 text-brand-sage text-lg leading-relaxed">
          A five-step path from first call to disbursal — designed to protect
          your time, your credit profile, and your downside.
        </p>
      </div>

      <ol className="mt-14 space-y-5">
        {PROCESS_STEPS.map((s, i) => (
          <li
            key={s.n}
            data-testid={`process-step-${i}`}
            className="card-soft grid md:grid-cols-12 gap-6 p-7 md:p-9 transition-all hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(17,42,34,0.25)]"
          >
            <div className="md:col-span-2">
              <div className="font-outfit font-extrabold text-5xl text-brand-terracotta">{s.n}</div>
            </div>
            <div className="md:col-span-7">
              <h3 className="font-outfit font-bold text-2xl text-brand-forest">{s.title}</h3>
              <p className="mt-3 text-brand-sage leading-relaxed">{s.desc}</p>
            </div>
            <div className="md:col-span-3 flex md:justify-end items-center">
              <div className="h-1 w-full md:w-12 bg-gradient-to-r from-transparent via-brand-gold to-brand-terracotta rounded-full" />
            </div>
          </li>
        ))}
      </ol>

      <section className="mt-20 grid md:grid-cols-12 gap-8 items-start">
        <div className="md:col-span-5">
          <span className="eyebrow">Referral Guide</span>
          <h2 className="mt-4 h-display text-3xl sm:text-4xl">
            Who to refer to us.
          </h2>
          <p className="mt-4 text-brand-sage leading-relaxed">
            A quick checklist for partners and friends — if anyone
            in your circle fits one of these profiles, a warm intro is gold.
          </p>
          <Link to="/contact" data-testid="process-refer-btn" className="btn-primary mt-7">
            Send a Referral <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <ul className="md:col-span-7 grid sm:grid-cols-2 gap-3">
          {REFERRAL_LIST.map((r, i) => (
            <li
              key={r}
              data-testid={`process-refer-${i}`}
              className="flex items-start gap-3 rounded-xl border border-brand-sand bg-white px-4 py-3.5 text-sm text-brand-forest/85"
            >
              <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-brand-forest text-brand-gold text-[11px] font-bold">{i + 1}</span>
              {r}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
